<template>
  <div id="form-register" class="form absolute" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm, xs:$vuetify.breakpoint.xs}">
        <a href="https://tasko.xyz" class="d-block">
            <img width="70px" height="70px" src="./../../assets/images/auth/Group 593.png" class="d-block">
            <img  class="mt-4 mx-auto d-block" width="60.9px" height="16.99px" src="./../../assets/images/auth/Tasko.png">
        </a>
        <div class="form-group mt-9">
            <template v-if="!sended">
                <div class="mt-12 roboto-normal-20 clr-black-28 text-center">Зарегистрировать аккаунт</div>
                <input 
                    class="mt-10 mx-auto input-auth d-block" 
                    placeholder="Укажите адрес электронной почты" 
                    v-model="registerEmail" 
                    @blur="errorEmailFlag = true" 
                    :class="{invalid: errorEmailFlag && !validEmail}"
                >
                <div class="input-error roboto-normal-14 ml-10 ml-lg-12 mt-1" v-if="errorEmailFlag && !validEmail">Неверный формат email.</div>
                <div class="relative">
                    <input 
                        type="password" 
                        class="mt-2 mx-auto d-block input-auth" 
                        placeholder="Введите пароль" 
                        v-model="registerPassword" 
                        @blur="registerPasswordFlag = true"
                        :class="{invalid: registerPasswordFlag && !validPassword}"
                    >
                    <img 
                        class="absolute image-information pointer" 
                        width="20px" height="20px"
                        src="./../../assets/images/auth/info_circle_outline.png"
                        @click="showInformation = !showInformation"
                    >
                    <div class="absolute block-information" v-show="showInformation" :class="{xs:$vuetify.breakpoint.xs}">
                            <v-icon small color="grey lighten-1" class="close" @click="showInformation = false">mdi-close</v-icon>
                            <div class="ml-4 roboto-normal-12 clr-black-9d">Пароль должен содержать:</div>
                            <div class="ml-4 roboto-normal-12 clr-black-9d">• 8 и более символов;</div>
                            <div class="ml-4 roboto-normal-12 clr-black-9d">• цифры;</div>
                            <div class="ml-4 mb-4 roboto-normal-12 clr-black-9d">• латинские буквы.</div>
                    </div>
                </div>
                <div class="input-error roboto-normal-14 ml-lg-12 ml-10 mt-1" v-if="registerPasswordFlag && !validPassword">Неверный формат пароля.</div>
                <div class="input-error roboto-normal-14 ml-lg-12 ml-10" v-if="registerPasswordFlag && !validPassword">Пароль должен содержать не менее 8 символов,</div>
                <div class="input-error roboto-normal-14 ml-lg-12 ml-10" v-if="registerPasswordFlag && !validPassword">цифры и латинские  буквы.</div>
                <input 
                    type="password" 
                    class="mt-2 mx-auto d-block input-auth"
                    placeholder="Введите пароль еще раз"
                    v-model="registerPasswordRepeat"
                    @blur="errorPasswordRepeatFlag = true"
                    :class="{invalid: errorPasswordRepeatFlag && !validPasswordRepeat}"
                >
                <div class="input-error roboto-normal-14 ml-10 ml-lg-12 d-block mt-1" v-if="errorPasswordRepeatFlag && !validPasswordRepeat">Пароли не совпадают.</div>
                <div class="mt-7 roboto-normal-13 ml-auto d-block clr-black-9d description">Регистрируясь, вы подтверждаете, что принимаете наши 
                    <span class="roboto-normal-13 clr-blue pointer"> 
                        <span @click="toPersonalAgreement()"> Условия использования </span> 
                        <span class="clr-black-9d">и</span> <span @click="toDataPolitic()"> Политику конфиденциальности. </span>
                    </span>
                </div>
                <button 
                    class="py-3 mt-8 text-capitalize button-auth"
                    :disabled="!showActiveSubmit || haveRegistred"
                    :class="{submit: showActiveSubmit, xs:$vuetify.breakpoint.xs}"
                    @click.once="register()"
                >Продолжить
                </button>
            </template>
            <div class="info-text mt-10 ml-10 ml-lg-12" v-else>Письмо с подтверждением уже отправлено на {{registerEmail}}</div>
            <!-- <div class="flex-center mt-12 px-11">
                <div class="roboto-normal-16 clr-black-66">или войти через:</div>
                <img class="ml-12 pl-5 pointer" src="./../../assets/images/auth/Google.png">
                <img class="ml-5 pointer" src="./../../assets/images/auth/Vk.png">
                <img class="ml-5 pointer" src="./../../assets/images/auth/Facebook.png">
            </div> -->
            <div v-if="sended">
                <div class="mt-3 clr-black-66 text-center roboto-normal-16">Не пришло письмо?</div>
                <div class="mt-3 clr-black-66 text-center roboto-normal-16">Проверьте папку "Спам"</div>
                <button 
                    class="py-3 mt-8 my-12 button-auth"
                    :class="{submit: !counterTimer, xs:$vuetify.breakpoint.xs, resend: showActiveSubmit, timer: counterTimer}"
                    :disabled="counterTimer >= 1 || pending"
                    @click="resendLetter()"
                    
                >{{counterTimer >= 1 ? "Отправить через " + counterTimer + " секунд" : "Отправить еще раз"}}
                </button>
            </div>
            <div class="mt-9 border mx-auto" :class="{xs:$vuetify.breakpoint.xs}"></div>
            <div class="mt-6 mb-12 clr-blue pointer text-center roboto-normal-16" @click="toLogin()">Уже есть аккаунт? Войти</div>
        </div>
        <cookie-consent :message="message" :linkLabel="linkLabel" :buttonLabel="buttonLabel"/>
  </div>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';
    import { searchEmail, searchPassword } from '../../helpers'
    export default {
        name: 'Register',
        data(){
            return {
                pending: false,
                haveRegistred: false,
                registerPasswordFlag: false,
                sended: false,
                registerEmail: this.$route.query.email || '',
                registerPassword: '',
                registerPasswordRepeat: '',
                errorEmailFlag: false,
                errorPassword: false,
                errorPasswordRepeat: false,
                showInformation: false,
                localHost: window.location.origin,
                errorPasswordRepeatFlag: false,
                counterTimer: 60,
                message: "Этот веб-сайт использует файлы cookie, чтобы обеспечить вам наилучший опыт работы на нашем веб-сайте.",
                linkLabel: "Узнать подробнее",   
                buttonLabel: "Ясно"
            }
        },
        computed: {
            validEmail() {
                return searchEmail(this.registerEmail)
            },
            validPassword() {
                return searchPassword(this.registerPassword)
            },
            validPasswordRepeat() {
                return (this.registerPassword === this.registerPasswordRepeat)
            },
            showActiveSubmit() {
                return this.registerEmail && this.registerPassword && this.registerPasswordRepeat ? true : false
            }
        },
        methods: {
            ...mapActions(['signUp', 'repeatSignUp']),
            ...mapMutations(['SET_ERROR']),   
            toShowErrorPassword() {
                this.validPassword ? this.errorPassword = false : this.errorPassword = true
            },
            toLogin() {
                this.$router.push('/login')
            },
            async register() {
                try{
                    if(this.showActiveSubmit && this.validPasswordRepeat) {
                        this.haveRegistred = true
                        this.errorPasswordRepeatFlag = true
                        this.errorEmailFlag = true
                        this.registerPasswordFlag = true
                        const user = await this.signUp({email: this.registerEmail, lpId: this.$route.query.lpId, password: this.registerPassword, registerKey: this.registerEmail + '|' + +new Date()})
                        if (user.active) {
                            this.$router.push('/login')
                        }
                        this.sended = true
                        this.timerForResend()
                    // this.toLogin()
                    }
                } catch(e){
                    this.SET_ERROR('Ошибка регистрации: пользователь с этим именем был уже зарегистрирован')
                }   
            },
            toDataPolitic() {
                window.location=`${this.localHost}/terms/data_politic_en.html`
            },
            toPersonalAgreement() {
                window.location=`${this.localHost}/terms/personal_agreement_en.html`
            },
            toUserAgreement() {
                window.location=`${this.localHost}/terms/user_agreement_en.html`
            },
            toLicense() {
                window.location=`${this.localHost}/terms/license_en.html`
            },
            timerForResend() {
                if (this.counterTimer) {
                    return setTimeout(() => {
                        --this.counterTimer
                        this.timerForResend()
                    }, 1000)
                }
            },
            async resendLetter() {
                try {                
                    this.pending = true
                    this.counterTimer = 60
                    this.timerForResend()
                    await this.repeatSignUp({email: this.registerEmail})
                    this.pending = false
                } catch (e) {
                    this.pending = false
                    console.error('Ошибка повторной отправки письма' + e)
                    this.SET_ERROR('Ошибка повторной отправки письма: ' + e)
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
#form-register {
    .input-error{
        max-width: 80%;
    }
    .info-text{
        max-width: 80%;
        color:#666666;
    }
    .description{
        max-width: 80%;
        margin-left: auto;
        margin-right: auto;
    }
    input::placeholder {
        color:#BEBEBE;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
    } 
    input:focus::-webkit-input-placeholder {
        color:#666666;
    }
    .image-information {
        top: calc(50% - 10px);
        right:14%
    }
    .block-information {
        display:flex;
        flex-direction: column;
        top:35%;
        right:-22%;
        width: 154px;
        height: auto;
        background:#FFFFFF;
        box-shadow: 0px 1px 8px -2px rgba(0, 0, 0, 0.25);
        border-radius: 0px 12px 12px 12px;
        &.xs {
           right:20%;
           border-radius: 12px 0px 12px 12px;
        }
    }
    .close {
        margin:3px 0 0 130px;
    }
    .border {
        border: 1px solid #D6D6D6;
        max-width: 80%;
    }
}
</style>